import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { entraAuthService } from './auth.service';
import { config } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService {
  private timeoutId: any;
  private timeoutDuration: number;

  private sessionExpiredSubject = new BehaviorSubject<boolean>(false);
  public sessionExpired$ = this.sessionExpiredSubject.asObservable();

  constructor(
    private router: Router,
    private entraAuthService: entraAuthService
  ) {
    this.timeoutDuration = config.sessionTimeout || 2 * 60 *60 * 1000; // 2 hours default
  }

  startTimeout(): void {
    if (!this.entraAuthService.isLoggedIn()) return;
    
    const storedLoginTime = localStorage.getItem('loginTime');
    if (!storedLoginTime) {
      const loginTime = Date.now();
      localStorage.setItem('loginTime', loginTime.toString());

      this.timeoutId = setTimeout(() => {
        this.expireSession();
      }, this.timeoutDuration);
    }
  }

  checkSession(): boolean {
    if (!this.entraAuthService.isLoggedIn()) return false;
    
    const storedLoginTime = localStorage.getItem('loginTime');
    if (!storedLoginTime) return false;
    
    const elapsed = Date.now() - parseInt(storedLoginTime);
    if (elapsed >= this.timeoutDuration) {
      this.expireSession();
      return false;
    }
    return true;
  }

  stopTimeout(): void {
    this.clearTimeouts();
    localStorage.removeItem('loginTime');
  }

  private clearTimeouts(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  private expireSession(): void {
    this.clearTimeouts();
    localStorage.removeItem('loginTime');
    sessionStorage.clear();
    indexedDB.deleteDatabase('ba_ndc');
    indexedDB.deleteDatabase('ba_ndc_21');
    this.sessionExpiredSubject.next(true);
    this.entraAuthService.initLogin();
    this.router.navigate(['/home']);
  }
}